module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/logo-coj-ja-89422b0b7bb3b20a9e44744c513cee75.png";